import { Job } from "~/components/build/Show/lib/types";
import { SortFn } from ".";
import { AgentIcon } from "~/components/job/Job/Agent";

export function Agent({ job }: { job: Job }) {
  if (!job.agentPath || job.type !== "script") {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      <AgentIcon os={job?.instanceShape?.operatingSystem} />
      <a
        tabIndex={-1}
        href={job.agentPath}
        // eslint-disable-next-line react/jsx-no-bind, id-length
        onClick={(e) => e.stopPropagation()}
        className="max-w-full truncate text-inherit hover:text-inherit focus:text-inherit"
      >
        {job.agentName}
      </a>
    </div>
  );
}

// eslint-disable-next-line id-length
export const sortByAgent: SortFn = (direction) => (a, b) => {
  if (direction === "asc") {
    return b.agentName?.localeCompare(a.agentName);
  }
  return a.agentName?.localeCompare(b.agentName);
};
